import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#a)\"><path fill=\"#039BE5\" d=\"M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24\"></path><path fill=\"#fff\" d=\"M13.623 15.18h3.105l.488-3.154h-3.594v-1.724c0-1.311.428-2.473 1.654-2.473h1.97V5.076c-.346-.047-1.078-.15-2.461-.15-2.888 0-4.582 1.526-4.582 5.001v2.099H7.234v3.154h2.97v8.671c.587.089 1.183.149 1.794.149.553 0 1.092-.05 1.625-.123z\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"></path></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }